module.exports = __webpack_public_path__ + "static/media/Astron_1_t.204b9e05.jpg";